//@ts-check

let activeStickyHeader;

/**
 * This represents the UI component for the product sticky header, which floats at the top of
 * the page after passing its rendering parameter
 */
export default class StickyHeader {
    /**
     * This creates the passing component. It also defines the event listener.
     * @param {HTMLElement} el - The dom element of the passing component
     */
    constructor(el) {
        this.el = el;
        /**@type {HTMLElement} */
        this.offsetParent = (el.offsetParent);
        this.scrollOffset = this.offsetParent.offsetTop;
        this.topOffset = el.offsetTop; //The offset from it's parent container

        //Need to check against this due to the possibility of alerts appearing and being dismissed.
        this.bodyHeight = document.body.clientHeight;

        this.setEventHandlers();
    }

    /**
     * Initializes the sticky header on the page.
     */
    static init() {
        /**@type {HTMLElement} */
        const stickyHeader = (document.getElementById('sticky-header'));

        if(stickyHeader) {
            activeStickyHeader = new StickyHeader(stickyHeader);
        }
        else {
            console.warn('No sticky header component present. Please try reloading.')
        }
    }

    /**
     * Checks the stored body height against the current body height.
     * This can change due to alerts and other dynamic content populating
     * and also being dismissed.
     */
    checkBodyHeight() {
        const clientHeight = document.body.clientHeight;
        if (clientHeight !== this.bodyHeight) {
            this.bodyHeight = clientHeight;
            this.updateOffsets();
        }
    }

    /**
     * Toggles the show class of the sticky header.
     */
    toggleStickyHeader() {
        this.checkBodyHeight();

        // pageYOffset is the IE11 version of scrollY.
        const scrollDistance = window.scrollY ? window.scrollY : window.pageYOffset;

        if (scrollDistance >= this.scrollOffset + this.topOffset) {
            this.el.classList.add('show');
            this.el.setAttribute('aria-expanded', 'true');
        }
        else{
            this.el.classList.remove('show');
            this.el.setAttribute('aria-expanded', 'false');
        }
    }

    /**
     * Sets the event listeners for the sticky header component.
     */
    setEventHandlers() {
        window.addEventListener('scroll', () => {
            this.toggleStickyHeader();
        }) ;
        document.body.addEventListener('resize', () => {
            this.updateOffsets();
        });
    }

    /**
     * Updates the offset values of the sticky header.
     */
    updateOffsets() {
        this.scrollOffset = this.offsetParent.offsetTop;
        this.topOffset = this.el.offsetTop;
    }
}